export default __webpack_public_path__ + "static/media/japantrad1.5e3f1bed.jpg";